import { Component, computed, inject, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection } from '@fcom/core-api';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

interface TextWithIcon {
  iconName: SvgLibraryIcon;
  text: string;
}

@Component({
  selector: 'cms-list-with-icons',
  templateUrl: './cms-list-with-icons.component.html',
  styleUrls: ['./cms-list-with-icons.component.scss'],
  standalone: false,
})
export class CmsListWithIconsComponent {
  private themeService = inject(FinnairThemeService);

  content = input.required<CmsCollection>();
  useTeaserTitle = input<boolean>();

  items = computed((): TextWithIcon[] => {
    const items = this.content()?.items ?? [];
    return items.map((item) => {
      return {
        text: this.useTeaserTitle() ? item.teaserTitle : item.teaserText,
        iconName: item.localSettings?.iconName as SvgLibraryIcon,
      };
    });
  });

  isNewBrand = computed(() => {
    return this.themeService.siteTheme() !== FinnairTheme.LEGACY;
  });
}
